export default __webpack_public_path__ + "static/media/bigtitle.0c6aace2.png";